import React from "react";

type ButtonType = {
  secondary?: boolean;
  disabled?: boolean;
  children: string;
  onClick: () => void;
};

const CustomButton = ({
  children,
  disabled,
  secondary,
  onClick,
}: ButtonType) => {
  return (
    <button
      className={`btn ${disabled ? "btn-disabled" : ""} ${
        secondary
          ? "bg-white text-primary border-1 border-primary shadow-none"
          : "bg-primary text-white"
      } w-full rounded-none`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default CustomButton;
